<template>
  <CModal
    title="แก้ไขหนังสือ"
    :show.sync="isShow"
    :closeOnBackdrop="false"
    @update:show="closeModal"
    centered
  >
    <CRow>
      <CCol sm="12">
        <CInput
          label="ชื่อหนังสือ **"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.name"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CTextarea
          label="รายละเอียดบทความ **"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.detail"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CInput
          label="ผู้แต่ง **"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.author.name"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CInput
          label="ผู้แปล **"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.translatorName"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CInput
          label="สำนักพิมพ์ **"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.factoryName"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CSelect
          label="หมวดหมู่หนังสือ **"
          :options="categories"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.category.id"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CInput
          label="จำนวนบท"
          type="number"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.allChapterCount"
          readonly
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CInput
          label="จำนวนหน้า"
          type="number"
          :horizontal="{ label: 'col-sm-4', input: 'col-sm-8' }"
          v-model="info.pageCount"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <CInputCheckbox label="เปิดให้ผู้อื่นอ่านร่วม" :checked.sync="checkbox" />
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="12">
        <label for="image-file">ภาพหมวดหมู่</label>
        <CInputFile @change="imageChange" :value="null" />
      </CCol>
    </CRow>

    <CRow v-if="errorMessage">
      <CCol sm="12" class="text-danger text-center">
        <span v-html="errorMessage"></span>
      </CCol>
    </CRow>

    <template slot="footer">
      <CButton color="secondary" variant="outline" @click="cancle">
        ยกเลิก
      </CButton>
      <CButton color="success" @click="confirm">
        ยืนยัน
      </CButton>
    </template>
  </CModal>
</template>

<script>
import apiBook from '@/apis/book'
import apiBookCategory from '@/apis/book_category'

export default {
  name: 'BookEditModal',
  props: {
    onComplete: Function
  },
  data() {
    return {
      isShow: false,
      categories: [],
      info: { author: {}, category: {} },
      infoUpdate: {
        id: '',
        name: '',
        isbn: '',
        detail: '',
        image: '',
        numPage: 0,
        categoryId: 0,
        authorName: '',
        factory: '',
        translator: '',
        chapterStatus: 0
      },
      checkbox: false,
      uploadImage: null,
      errorMessage: ''
    }
  },
  methods: {
    show(info) {
      this.isShow = true
      this.errorMessage = ''
      this.categories = []

      apiBookCategory
        .getListAll()
        .then((result) => {
          for (const doc of result.data.docs) {
            this.categories.push({
              value: doc._id,
              label: doc.name
            })
          }
        })
        .catch(() => {})

      apiBook
        .detail(info.id)
        .then((result) => {
          this.info = result.data.book
          this.checkbox = this.isPublic(this.info.chapterStatus)
        })
        .catch(() => {})
    },
    clear() {
      setTimeout(() => {
        this.info = { author: {}, category: {} }
      }, 500)
    },
    cancle() {
      this.isShow = false
      this.clear()
    },
    imageChange(files) {
      this.uploadImage = files[0]
    },
    async confirm() {
      if (!this.info.name) {
        this.errorMessage = 'ต้องกรอก <b>ชื่อหนังสือ</b>'
        return
      }
      if (!this.info.detail) {
        this.errorMessage = 'ต้องกรอก <b>รายละเอียดบทความ</b>'
        return
      }
      if (!this.info.author.name) {
        this.errorMessage = 'ต้องกรอก <b>ผู้แต่ง</b>'
        return
      }
      if (!this.info.translatorName) {
        this.errorMessage = 'ต้องกรอก <b>ผู้แปล</b>'
        return
      }
      if (!this.info.factoryName) {
        this.errorMessage = 'ต้องกรอก <b>สำนักพิมพ์</b>'
        return
      }
      if (!this.info.category.id) {
        this.errorMessage = 'ต้องเลือก <b>หมวดหมู่หนังสือ</b>'
        return
      }
      try {
        if (this.uploadImage) {
          const response = await apiUpload.uploadImage(this.uploadImage)
          this.info.image = response.data[0].name
        }

        this.infoUpdate.id = this.info.id
        this.infoUpdate.name = this.info.name
        this.infoUpdate.isbn = this.info.isbn
        this.infoUpdate.detail = this.info.detail
        this.infoUpdate.image = this.info.image
        this.infoUpdate.numPage = this.info.pageCount
        this.infoUpdate.categoryId = this.info.category.id
        this.infoUpdate.authorName = this.info.author.name
        this.infoUpdate.factory = this.info.factoryName
        this.infoUpdate.translator = this.info.translatorName
        this.infoUpdate.chapterStatus = this.checkbox ? 2 : 1

        apiBook.update(this.infoUpdate).then(() => {
          this.onComplete()
        })

        this.isShow = false
        this.clear()
      } catch {}
    },
    closeModal() {
      this.clear()
    },
    isPublic(chapterStatus) {
      return chapterStatus === 2 ? true : false
    }
  }
}
</script>
